import { useEffect } from "react";
import { Home } from "../../../apps/home";
import { AuthView, useAuthModal } from "./AuthModalContext";

// /sign-in, /sign-up and /forget-password show the home page with the auth modal open
export const AuthRoute = ({ view }: { view: AuthView }) => {
  const { openAuth } = useAuthModal();

  useEffect(() => {
    openAuth(view);
  }, [openAuth, view]);

  return <Home />;
};
